import { useLocation, useNavigate } from 'react-router-dom';

import introduceBanner from '@/assets/img/banner/introduce.jpg';
import SubBanner from '@/components/common/Banner/SubBanner/SubBanner';
import TabList from '@/components/common/Tab/TabList/TabList';
import ExecutiveList from '@/components/Introduce/ExecutiveList/ExecutiveList';
import History from '@/components/Introduce/History/History';
import IntroduceOwner from '@/components/Introduce/IntroduceOwner/IntroduceOwner';
import Maps from '@/components/Introduce/Maps/Maps';
import Organization from '@/components/Introduce/Organization/Organization';
import Rules from '@/components/Introduce/Rules/Rules';

const Introduce = () => {
	const location = useLocation();
	const navigate = useNavigate();

	const params = location.state?.menu ?? '학회소개';
	const tabList = ['학회소개', '학회 조직도', '학회연혁', '정관 및 규정', '임원', '오시는길'];

	const handleMenuName = (menu: string) => {
		navigate('/introduce', { state: { menu: menu } });
	};

	return (
		<main>
			<SubBanner subTitle="Introduction to the society" title="학회소개" img={introduceBanner} />
			<TabList menuList={tabList} menuKey={params} onListClick={handleMenuName} />
			{params === tabList[0] && <IntroduceOwner />}
			{params === tabList[1] && <Organization />}
			{params === tabList[2] && <History />}
			{params === tabList[3] && <Rules />}
			{params === tabList[4] && <ExecutiveList />}
			{params === tabList[5] && <Maps />}
		</main>
	);
};

export default Introduce;
